<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <AppSection id="dashboard" :is-section-loading="isLoadingData" :title="$getConst.menu.timesheets.name" type="page">
    <Page500 v-if="!checkNavAPI || hasRole(this.$getConst.roles.SUPER_ADMIN) || hasRole(this.$getConst.roles.LOCAL_ADMIN)"></Page500>
    <div v-else>

      <b-tabs v-model="activeTab" lazy>

        <b-tab @click="$router.push({hash: 'tab-1'})" title-link-class="h-100">

          <template v-slot:title>
            <AppSvgIcon
              height="2rem"
              :icon="$getConst.svgIcons.plane_paper"
            />
            <label class="text-primary font-weight-bold" >{{titleToDo}}</label>
            <p class="text-break text-primary mb-0 ml-3">{{descriptionToDo}}</p>
          </template>

          <TimesheetsList
            is-to-validate
            :is-loading-data="isLoadingData"
            @is-loading-data="isLoadingData = $event"
            :check-nav-api="checkNavAPI"
            @check-nav-api="checkNavAPI = $event"
          />

        </b-tab>

        <b-tab @click="$router.push({hash: 'tab-2'})" title-link-class="h-100">

          <template v-slot:title>
            <AppSvgIcon
              height="2rem"
              :icon="$getConst.svgIcons.clock_checked_success"
            />
            <label class="text-primary font-weight-bold">{{title}}</label>
            <p class="text-break text-primary mb-0 ml-3">{{description}}</p>
          </template>

          <TimesheetsList
            :is-loading-data="isLoadingData"
            @is-loading-data="isLoadingData = $event"
            :check-nav-api="checkNavAPI"
            @check-nav-api="checkNavAPI = $event"
          />

        </b-tab>

      </b-tabs>

    </div>
  </AppSection>
</template>

<script>

  import AppSection from "../../../components/common/sections/AppSection";
  import Page500 from "../../utils/Page500";
  import TimesheetsList from "./TimesheetsList";

  export default {
    name: 'dashboard',
    components: {TimesheetsList, AppSection, Page500},
    data() {
      return {
        activeTab: 0,
        isLoadingData: false,
        checkNavAPI: true,
        titleToDo: null,
        descriptionToDo: null,
        title: null,
        description: null,
      }
    },
    created() {
      // initialise titles
      if (this.isWorker()) {
        this.titleToDo = this.$t(this.$getConst.pages.timesheet.to_submit);
        this.descriptionToDo = this.$t(this.$getConst.pages.timesheet.to_submit_description);
        this.title = this.$t(this.$getConst.pages.timesheet.submitted);
        this.description = this.$t(this.$getConst.pages.timesheet.submitted_description);
      } else {
        this.titleToDo = this.$t(this.$getConst.pages.timesheet.to_approve);
        this.descriptionToDo = this.$t(this.$getConst.pages.timesheet.to_approve_description);
        this.title = this.$t(this.$getConst.pages.timesheet.approved_title);
        this.description = this.$t(this.$getConst.pages.timesheet.approved_description);
      }

      if (this.$route.hash === "#tab-2") {
        this.activeTab = 1;
      }
    }
  }
</script>

<style scoped>

</style>
